import { createStore } from 'redux'

const options = [
  { value: 'device_id', label: 'Device Id' },
  { value: 'train_no', label: 'Train No' },
  { value: 'timestamp', label: 'Time' },
  { value: 'train_dir', label: 'Train Dir' },
  { value: 'rake_subtype', label: 'Rake Type' },
  { value: 'coach_count', label: 'Coach Count' },
  { value: 'axle_count', label: 'Axle Count' },
  { value: 'max_right_temp', label: 'Max Right Temp' },
  { value: 'max_left_temp', label: 'Max Left Temp' },
  { value: 'max_diff_temp', label: 'Max Diff Temp' },
  { value: 'max_right_wheel_temp', label: 'Right Wheel Temp' },
  { value: 'max_left_wheel_temp', label: 'Left Wheel Temp' },
  { value: 'avg_speed', label: 'Avg Speed' },
  { value: 'feedback', label: 'Remarks' },
  { value: 'chart', label: 'chart' },
  { value: 'axle_Table', label: 'Axle Data Table' },
];
const supoptions = [
  { value: 'axle_index_train', label: 'Axle Index Train' },
  { value: 'axle_index_coach', label: 'Axle Index Coach' },
  { value: 'timestamp', label: 'Time' },
  { value: 'right_temp', label: 'Right Temp' },
  { value: 'left_temp', label: 'Left Temp' },
  { value: 'diff_temp', label: 'Diff Temp' },
  { value: 'right_wheel_temp', label: 'Right Wheel Temp' },
  { value: 'left_wheel_temp', label: 'Left Wheel Temp' },
  { value: 'speed', label: 'Speed' },
  { value: 'remarks', label: 'Edit' },
  { value: 'spread_comparison', label: 'Spread Comparison' },

];
const suboptions = [
  { value: 'rake_position', label: 'Rake Position' },
  { value: 'reverse_position', label: 'Reverse Position' },
  { value: 'coach_position', label: 'Position' },
  { value: 'timestamp', label: 'Time' },
  { value: 'coach_type', label: 'Type' },
  { value: 'coach_subtype', label: 'Subtype' },
  { value: 'max_right_temp', label: 'Max Right Temp' },
  { value: 'max_left_temp', label: 'Max Left Temp' },
  { value: 'max_diff_temp', label: 'Max Diff Temp' },
  { value: 'max_right_wheel_temp', label: 'Right Wheel Temp' },
  { value: 'max_left_wheel_temp', label: 'Left Wheel Temp' },
  { value: 'avg_speed', label: 'Avg Speed' },
  { value: 'edit', label: 'Edit' },
];
const initialState = {
  sidebarShow: false,
  help :false,
  globalHelp :false,
  expandedData:false ,
  visibleColumn: options.map(option => option.value),
  visibeSubColumn:suboptions.map((option)=>option.value),
  visiblesupColumn :supoptions.map((option)=>option.value)
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'TRIGGER_HELP_TOUR':
      return { ...state, help: true }
    case 'RESET_HELP_TOUR':
      return { ...state, help: false }
      case 'TRIGGER_Global_HELP_TOUR':
      return { ...state, globalHelp: true }
    case 'RESET_Global_HELP_TOUR':
      return { ...state, globalHelp: false }
    case 'set':
      return { ...state, ...rest }
    case "visible_Column":
      return {...state , visibleColumn: rest.columns}
    case "visible_SubColumn":
        return {...state , visibeSubColumn: rest.columns}
    case "visible_SupColumn":
        return {...state , visiblesupColumn: rest.columns}
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
